/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Aleksandr Perkhunov
 * @version 1.1.0
 * @since 1.0.1
 */

import { IAction, IActionWithPayload } from '../../../../../modules/app/createAction';
import {
    LOAD_WIDGET_SUBSCRIBER_MOBILE_FAIL,
    LOAD_WIDGET_SUBSCRIBER_MOBILE_REQUEST,
    LOAD_WIDGET_SUBSCRIBER_MOBILE_SUCCESS,
    WIDGET_SUBSCRIBER_MOBILE_REDIRECT,
} from './widgetSubscriberMobileConstants';

export enum EWidgetSubscriberMobile {
    LABELS = 'labels',
    TARIFFS = 'tariffs',
}

export interface IWidgetSubscriberMobileItem {
    count: number;
    id: number;
    name: string;
}

export interface IWidgetSubscriberMobileSuccessProps {
    activeSubs: IWidgetSubscriberMobileStatusSubs;
    blockedSubs: IWidgetSubscriberMobileStatusSubs;
    labels: IWidgetSubscriberMobileItem[];
    noSimCardSubs: IWidgetSubscriberMobileStatusSubs;
    tariffs: IWidgetSubscriberMobileItem[];
}

export interface IWidgetSubscriberMobileReducer {
    data: IWidgetSubscriberMobileSuccessProps;
    error: string;
    loading: boolean;
}

export interface IWidgetSubscriberMobileStatusSubs {
    count: number;
    names: string[];
}

export type TLoadSubscribersStatusesRequestAction =
    IAction<typeof LOAD_WIDGET_SUBSCRIBER_MOBILE_REQUEST>;

export type TLoadSubscribersStatusesSuccessAction =
    IActionWithPayload<typeof LOAD_WIDGET_SUBSCRIBER_MOBILE_SUCCESS, IWidgetSubscriberMobileSuccessProps>;

export type TLoadSubscribersStatusesFailAction =
    IActionWithPayload<typeof LOAD_WIDGET_SUBSCRIBER_MOBILE_FAIL, string>;

export type TWidgetSubscribersMobileRedirectAction =
    IActionWithPayload<typeof WIDGET_SUBSCRIBER_MOBILE_REDIRECT, string>;

export type TWidgetSubscriberMobileAction =
    TLoadSubscribersStatusesFailAction
    | TLoadSubscribersStatusesRequestAction
    | TLoadSubscribersStatusesSuccessAction
    | TWidgetSubscribersMobileRedirectAction
    ;
